import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { useMediaQueries } from '@web/react-hooks';
import { FooterSection } from './FooterSection.js';
import { MenuItem } from './MenuItem.js';

const MenuItemsWrapper = styled.div`
  display: inline-flex;
  justify-content: center;
  text-align: center;
  flex-wrap: wrap;
  flex: 0 1 auto;
`;
const MenusSection = ({
  menus,
  onSelect,
  ...rest
}) => {
  const {
    screenMd
  } = useMediaQueries();
  if (!menus) return null;
  return jsx(FooterSection, Object.assign({}, rest, {
    children: jsx(MenuItemsWrapper, {
      children: menus.map(({
        name,
        items
      }) => jsx(MenuItem, {
        isNativeSelect: !screenMd,
        items: items,
        name: name,
        onSelect: onSelect
      }, name))
    }, void 0)
  }), void 0);
};
MenusSection.displayName = 'MenusSection';

export { MenusSection };
